import React, { memo } from 'react'

import { TagComponent as Tag } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import FreeBetaBody from 'Pods/ThreeDStudio/Shared/UsageBodies/FreeBetaBody/FreeBetaBody'
import HasCreditsBody from 'Pods/ThreeDStudio/Shared/UsageBodies/HasCreditsBody/HasCreditsBody'
import SubscribedBody from 'Pods/ThreeDStudio/Shared/UsageBodies/SubscribedBody/SubscribedBody'
import UpgradeBody from 'Pods/ThreeDStudio/Shared/UsageBodies/UpgradeBody/UpgradeBody'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { closeSettingsModal } from 'Pods/ThreeDStudio/Store/actions/ui'
import { CREDITS_STUDIO_ACCESS_TIERS, STUDIO_ACCESS_TIER } from 'Pods/ThreeDStudio/Store/constants'

const renderTag = (studioAccessTier, t) => {
  switch (studioAccessTier) {
    case STUDIO_ACCESS_TIER.IN_FREE_BETA:
      return (
        <Tag className="settings-modal__tag settings-modal__tag--free">
          {t('usageModal.tags.freePlan')}
        </Tag>
      )
    case STUDIO_ACCESS_TIER.SUBSCRIBED:
      return <Tag color="primary-24" className="settings-modal__tag">{t('usageModal.tags.subscription')}</Tag>
    default:
      return null
  }
}

function UsageTab() {
  const t = useTranslation()
  const studioAccessTier = useThreeDStudioStore(state => state.subscription.studioAccessTier)
  const monthlyUsed = useThreeDStudioStore(state => state.subscription.monthlyGenerationsUsed)
  const monthlyAvailable = useThreeDStudioStore(state => state.subscription.monthlyGenerationsAvailable)
  const availableCredits = useThreeDStudioStore(state => state.generation.availableCredits) || 0

  // Same rule as UsageModal: a drained trial can coexist with credits granted
  // outside it (admin, top-up); those users can still generate, so they get the
  // credits view instead of the exhausted-trial warning.
  const isTrialDrainedWithCredits = monthlyAvailable > 0
    && monthlyUsed >= monthlyAvailable
    && availableCredits > 0

  const renderBody = () => {
    if (!studioAccessTier) {
      return null
    }

    if (studioAccessTier === STUDIO_ACCESS_TIER.IN_FREE_BETA) {
      return isTrialDrainedWithCredits
        ? <HasCreditsBody onClose={closeSettingsModal} />
        : <FreeBetaBody onClose={closeSettingsModal} />
    }

    if (CREDITS_STUDIO_ACCESS_TIERS.has(studioAccessTier)) {
      return <HasCreditsBody onClose={closeSettingsModal} />
    }

    if (studioAccessTier === STUDIO_ACCESS_TIER.SUBSCRIBED) {
      return <SubscribedBody onClose={closeSettingsModal} />
    }

    return <UpgradeBody onClose={closeSettingsModal} />
  }

  return (
    <section className="settings-modal__tab" aria-label={t('usageModal.header.aiUsage')}>
      <div className="settings-modal__section-header">
        <h3 className="settings-modal__section-title cgt-heading-100">
          {t('usageModal.header.aiUsage')}
        </h3>
        {renderTag(studioAccessTier, t)}
      </div>
      {renderBody()}
    </section>
  )
}

export default memo(UsageTab)
